<div class="modal-header">
    <h4 class="modal-title">Vista Previa</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
    </button>
</div>
<div class="modal-body">
    <div class="contenedor">
        <div class="item-2">
            <div class="vista-previa">
                <img *ngIf="element.tipo == 1" class="imagen-vista-previa"
                    src="../../../../assets/system/preview_banner.png">
                <img *ngIf="element.tipo == 2" class="imagen-vista-previa"
                    src="../../../../assets/system/preview_popup.png">
                <div *ngIf="imgFile">
                    <img [src]="imgFile"
                        [ngClass]="{'banner-overlay': element.tipo == 1, 'popup-overlay': element.tipo == 2}">
                </div>
            </div>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="activeModal.dismiss('Cancel click')">Cerrar</button>
</div>